var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose2 = function SvgClose2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03773 6.00047L11.7848 1.25379C12.0717 0.966674 12.0717 0.502447 11.7848 0.217199C11.4979 -0.0699138 11.034 -0.0699138 10.749 0.217199L6 4.96201L1.25105 0.215334C0.964136 -0.0717781 0.500233 -0.0717781 0.215184 0.215334C-0.071728 0.502447 -0.071728 0.966674 0.215184 1.25192L4.96227 5.9986L0.215184 10.7471C-0.071728 11.0343 -0.071728 11.4985 0.215184 11.7837C0.35864 11.9273 0.546809 11.9981 0.733116 11.9981C0.921286 11.9981 1.10759 11.9273 1.25105 11.7837L6 7.03705L10.749 11.7856C10.8924 11.9292 11.0787 12 11.2669 12C11.4551 12 11.6414 11.9292 11.7848 11.7856C12.0717 11.4985 12.0717 11.0343 11.7848 10.749L7.03773 6.00047Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 2 2)",
    fill: "currentColor"
  })));
};
export default SvgClose2;